import { PopupDropdownMenu as DropdownMenu } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DayWithIcon } from './day_with_icons';
const weekdaysUseUpdatedStylesCss = "wj7iedv";
const weekdaysCss = "wm8lyw8";
export const Weekdays = forwardRef((props, ref) => {
  const {
    useUpdatedStyles,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tr';
  return <Component ref={ref} {...restProps} className={classNames(weekdaysCss, {
    [weekdaysUseUpdatedStylesCss]: useUpdatedStyles
  }, props.className)} />;
});
const weekdayUseUpdatedStylesCss = "wzev5nn";
const weekdayCss = "w1191h81";
export const Weekday = forwardRef((props, ref) => {
  const {
    useUpdatedStyles,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  return <Component ref={ref} {...restProps} className={classNames(weekdayCss, {
    [weekdayUseUpdatedStylesCss]: useUpdatedStyles
  }, props.className)} />;
});
const weekHorizontalSpacersCss = "w4owpfr";
const weekCss = "wmurs1a";
export const Week = forwardRef((props, ref) => {
  const {
    horizontalSpacers,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tr';
  return <Component ref={ref} {...restProps} className={classNames(weekCss, {
    [weekHorizontalSpacersCss]: horizontalSpacers
  }, props.className)} />;
});
const dayContainerCss = "dr70cy";
export const DayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  return <Component ref={ref} {...restProps} className={classNames(dayContainerCss, props.className)} />;
});
const menuPullLeftCss = "m1qdfar8";
const menuPullUpCss = "m10szz68";
const menuCss = "me49lt7";
export const Menu = forwardRef((props, ref) => {
  const {
    pullLeft,
    pullUp
  } = props;
  return <DropdownMenu ref={ref} {...props} className={classNames(menuCss, {
    [menuPullLeftCss]: pullLeft,
    [menuPullUpCss]: pullUp
  }, props.className)} />;
});
const dividerCss = "d1k0irrz";
export const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)} />;
});
const styledBodyCss = "s1o7t2eg";
export const StyledBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tbody';
  return <Component ref={ref} {...restProps} className={classNames(styledBodyCss, props.className)} />;
});
const styledHeaderCss = "s6ymuyp";
export const StyledHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'thead';
  return <Component ref={ref} {...restProps} className={classNames(styledHeaderCss, props.className)} />;
});
const styledDayWithIconCss = "s1izejza";
export const StyledDayWithIcon = forwardRef((props, ref) => <DayWithIcon ref={ref} {...props} className={classNames(styledDayWithIconCss, props.className)} />);
const calendarTableIsFullHeightCss = "c1732elo";
const calendarTableCss = "c5kot60";
export const CalendarTable = forwardRef((props, ref) => {
  const {
    isFullHeight,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'table';
  return <Component ref={ref} {...restProps} className={classNames(calendarTableCss, {
    [calendarTableIsFullHeightCss]: isFullHeight
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");